import React from 'react'
import './page.scoped.scss'
import PageTransition from './templateParts/PageTransition'
import Lottie from 'lottie-react'
import intro from '@/assets/lottie/404.json'
import { motion } from 'framer-motion'

export default function NotFound() {
  const parentVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.5,
      },
    },
  }

  const variants = {
    hidden: {
      opacity: 0,
      x: '20px',
    },
    visible: {
      opacity: 1,
      x: '0',
    },
  }

  return (
    <PageTransition>
      <motion.section
        className="not-found"
        variants={parentVariants}
        initial="hidden"
        animate="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <motion.div className="lottie-container" variants={variants}>
          <Lottie animationData={intro} loop={true} />
        </motion.div>
        <motion.p className="disclaimer" variants={variants}>
          Page not found
        </motion.p>

        <motion.div className="links-container" variants={variants}></motion.div>
      </motion.section>
    </PageTransition>
  )
}
